import { useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import TagManager from "react-gtm-module";
import "../../app/tim_prefs";
import { useTagManager } from "@/hooks/useTagManager";

export function Analytics() {
  const GTM_ID_OMEGA = import.meta.env.VITE_GOOGLE_TAGMANAGER_ID_OMEGA;
  const GTM_ID_ICHERRY = import.meta.env.VITE_GOOGLE_TAGMANAGER_ID_ICHERRY;
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { dataLayer } = useTagManager();

  useEffect(() => {
    // @ts-expect-error: nstim is a global object not recognized by TypeScript
    nstim?.initiate?.(null);
  }, []);

  useEffect(() => {
    if (GTM_ID_OMEGA) {
      TagManager.initialize({
        gtmId: GTM_ID_OMEGA,
        dataLayerName: "omegaDataLayer",
      });
    }
    if (GTM_ID_ICHERRY) {
      TagManager.initialize({ gtmId: GTM_ID_ICHERRY });
    }
  }, [GTM_ID_OMEGA, GTM_ID_ICHERRY]);

  useEffect(() => {
    if (location.pathname) {
      dataLayer({
        event: "pageview",
        page: location.pathname,
      });
    }
  }, [location.pathname, searchParams, dataLayer]);

  if (!GTM_ID_OMEGA && !GTM_ID_ICHERRY) {
    return null;
  }

  return (
    <>
      <input type="hidden" id="user_prefs" name="user_prefs" />
      <input type="hidden" id="user_prefs2" name="user_prefs2" />
    </>
  );
}
